<template>
  <div>
    <article class="con3" id="qna">
      <div class="container">
        <div class="main-list-wrapper">
          <p class="main-title">자주 묻는 질문</p>
          <ul class="qa-wrapper">
            <li>
              <p class="question">Q. 입사 지원 시 별도의 양식이 있나요?</p>
              <p class="answer">
                캐럿글로벌은 서류 검토를 위해 입사 시 이력서와 자기소개서를 받고
                있습니다.<br />두 개 모두 정해진 양식은 없으며, 지원자께서 가장
                편하고, 자신을 잘 나타낼 수 있는 양식으로 작성해주시면 됩니다.
              </p>
            </li>
            <li>
              <p class="question">
                Q. 입사지원서에는 파일 몇 개를 첨부할 수 있나요?
              </p>
              <p class="answer">
                파일 첨부 최대 개수는 1개입니다. 여러 파일을 첨부하실 경우
                압축하여 첨부를 부탁드립니다.
              </p>
            </li>
            <li>
              <p class="question">
                Q. 채용 중인 직무에 제가 원하는 직무가 없을 경우에는 어떡하나요?
              </p>
              <p class="answer">
                명시된 직군 외에도 지원자분께서 캐럿에 기여할 수 있다고 생각하는
                직무가 있으시면 '캐럿글로벌 인재Pool에 등록하기'<br />메뉴를
                통해 이력서를 첨부해주시거나, recruit@carrotglobal.com 으로
                지원을 부탁드립니다.
              </p>
            </li>
            <li>
              <p class="question">
                Q. 입사 지원 후 결과에 대한 회신이 없습니다.
              </p>
              <p class="answer">
                캐럿글로벌은 서류합격자에 한해 연락을 드리고 있습니다. 서류
                검토는 최소 일주일에서 직무에 따라 그 이상이 소요될 수
                있습니다.<br />무엇보다 지원자분들의 역량을 꼼꼼히 검토하기 위한
                과정이니 양해를 부탁드립니다.
              </p>
            </li>
          </ul>
        </div>
        <p class="inquiry">
          ※ 이외에 채용 관련 사항은 <span>recruit@carrotglobal.com</span>으로
          문의 부탁드립니다.
        </p>
      </div>
    </article>
  </div>
</template>

<script>
import "@/assets/style/newGlobalReset.scss";

export default {};
</script>

<style lang="scss" scoped>
.con3 {
  padding: 40px 0;

  @media screen and (min-width: 1350px) {
    padding: 80px 0;
  }

  .main-list-wrapper {
    margin-bottom: 20px;

    .main-title {
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px;

      @media screen and (min-width: 1350px) {
        font-size: 40px;
      }
    }

    .qa-wrapper {
      border-top: 2px solid #000000;
      border-bottom: 2px solid #000000;

      > li {
        padding: 30px;

        &:not(:last-child) {
          border-bottom: 1px solid #dddddd;
        }

        .question {
          font-weight: 700;
          margin-bottom: 12px;

          @media screen and (min-width: 1350px) {
            font-size: 20px;
          }
        }

        .answer {
          font-size: 14px;
          padding-left: 25px;

          @media screen and (min-width: 1350px) {
            font-size: 17px;
          }
        }
      }
    }
  }

  .inquiry {
    color: #969696;
    text-align: right;

    span {
      font-weight: 700;
    }
  }
}
</style>
